import "babel-polyfill";

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { getCLS, getFID, getFCP, getLCP, getTTFB } from "web-vitals";
import zhCN from 'antd/lib/locale/zh_CN';
import { ConfigProvider } from 'antd';
import LinkedAnimate from './background';
import { HashRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ConfigProvider locale={zhCN}>
      <HashRouter>
        <LinkedAnimate />
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          overflow: 'auto',
        }}>
          <App />
        </div>
      </HashRouter>
    </ConfigProvider>
  </React.StrictMode>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
const reportWebVitals = onPerfEntry => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    getCLS(onPerfEntry);
    getFID(onPerfEntry);
    getFCP(onPerfEntry);
    getLCP(onPerfEntry);
    getTTFB(onPerfEntry);
  }
};

const testSearchString = async () => {
  // Parse search string
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const id = params.get('id');
  if (id === null) {
    return;
  }
  document.getElementById('file-id').value = id;
  document.getElementById('file-get').click();
}

reportWebVitals(console.log);
testSearchString();
